(function trackerArticlesBoyl() {
  'use strict';

  const container = document.querySelector('[data-articles-boyl-section]');

  /**
   * @private
   * trackEvents: track events anchor boyl articles in the site.
   * @param {Event} event with the information of the click.
   *
   */
  function trackEvents(event) {
    const target = event.target.closest('a') || event.target;

    if (target.nodeName !== 'A') {
      return;
    }
    const eventGa4 = {
      eventName: 'learncenter_events',
      params: {
        click_target: target.innerText,
        destination: target.href
      },
      eventType: 'GA4Event'
    };
    document.body.dispatchEvent(new CustomEvent('trackOnDemandEvent', {
      detail: { data: eventGa4 }
    }));
  }

  if (container) {
    container.addEventListener('click', trackEvents);
  }
}());
